<template>
  <dx-modal :value="show" title="Impressão da capa do lote" size="sm" id="modal-batch-cover"
            :closable="!printing" @input="close()">
    <div class="cover-context">
      <b>Lote {{ batch.number }}</b>
      · {{ guideTypeName(batch.guideType) }}
      · {{ batch.quantity }} {{ batch.quantity === 1 ? 'guia' : 'guias' }}
      · <span class="num text-bold">{{ batch.totals.informed | currency }}</span>
    </div>
    <div class="form-group">
      <div class="text-bold">Selecione o que deseja exibir na capa</div>
      <label class="form-switch mt-1">
        <input type="checkbox" v-model="options.includeValues">
        <i class="form-icon"></i>Exibir valores das guias
      </label>
      <label class="form-switch mt-1">
        <input type="checkbox" v-model="options.includePassword">
        <i class="form-icon"></i>Exibir senha de autorização
      </label>
      <label class="form-switch mt-1">
        <input type="checkbox" v-model="options.groupByProfessional">
        <i class="form-icon"></i>Agrupar por profissional
      </label>
    </div>
    <template slot="footer">
      <button class="btn btn-gray btn-icon btn-icon-left mr-1"
              :class="{loading: printing === 'xlsx'}" :disabled="!!printing" @click="print('xlsx')">
        <fa-icon :icon="['fal', 'file-excel']"/>Gerar planilha
      </button>
      <button class="btn btn-primary btn-icon btn-icon-left mr-1"
              :class="{loading: printing === 'pdf'}" :disabled="!!printing" @click="print('pdf')">
        <fa-icon :icon="['fal', 'print']"/>Imprimir
      </button>
      <button class="btn" :disabled="!!printing" @click="close()">Sair</button>
    </template>
  </dx-modal>
</template>

<script>
import { guideTypeName } from '../service';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    batch: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      printing: null,
      options: {
        includeValues: true,
        includePassword: true,
        groupByProfessional: false,
      },
    };
  },
  methods: {
    guideTypeName,
    print(format) {
      this.printing = format;
      const route = `/billing-batches/${this.batch.id}/cover`;
      const params = { ...this.options, format };

      const request = format === 'xlsx'
        ? this.$file.download(route, params, { name: `capa-lote-${this.batch.number}.xlsx` })
        : this.$file.print(route, params);

      return request
        .then(() => {
          this.$toast.success('Capa gerada.');
        })
        .catch(() => {})
        .finally(() => {
          this.printing = null;
        });
    },
    close() {
      if (this.printing) return;
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
@import "../batch.scss";

#modal-batch-cover {
  .cover-context {
    background-color: $gray-color-ultra-light;
    border: $border-color solid $border-width;
    border-radius: $border-radius;
    font-size: $font-size-sm;
    margin-bottom: $layout-spacing-lg;
    padding: $layout-spacing $layout-spacing-lg;
  }
}
</style>
